module.exports = __webpack_public_path__ + "static/media/logo_geochicas_black_small@3x.225b9a6c.jpg";